import React, { useContext, useEffect, useState, useRef, useReducer, useMemo, useCallback } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, EditRowIcon, PaperClipIcon, EditIcon, DeleteIcon } from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { PanelMenu } from 'primereact/panelmenu';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { createAsyncNavigateHandlers } from '../../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../../utils/maintenanceNavigationContext';
import { getDateFormat } from '../../../utils/dateUtils';
import {
  cleanSorters,
  extractSafePaginationParams,
  createDedupedAjaxRequest,
  refreshProgressiveFromStart,
  mergePagedStandardListFiltersAndSorters,
  appendMaintenanceCompanyCertificateEmbeddedPagedFilter,
  restoreMaintenanceCompanyEmbeddedUserMaskToTable,
  applyMaintenanceCompanyEmbeddedColumnLayout,
} from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { primeMultiSelectHeaderFilter } from '../../../utils/primeMultiSelectHeaderFilter';
import { getEffectiveMask } from '../../../utils/effectiveMask';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../../utils/maintenanceTabulatorMaskActions';
import { getTabulatorPersistLayoutEvents } from '../../../utils/tabulatorPersistLayout';
import { inputOnEnterHeaderFilter } from '../../../utils/inputOnEnterHeaderFilter';
import { tabulatorColumnMinWidthFromTitle, TABULATOR_LIST_ID_MIN_WIDTH } from '../../../utils/tabulatorColumnMinWidth';
import {
  buildAuditTabulatorColumns,
  TABULATOR_AUDIT_PROFILES,
} from '../../../utils/tabulatorAuditColumns';
import {
  getEmbeddedCanonicalFieldOrder,
  getEmbeddedDefaultColumnVisibility,
  mergeEmbeddedColumnVisibilityFromSaved,
  applyEmbeddedDataColumnVisibility,
} from '../../../utils/maintenanceCompanyEmbeddedTabulator';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../../utils/printChrome';
import { uiT } from '../../../utils/uiTranslate';
import { showDeactivatedInLists } from '../../../utils/moduleSettings';

const MASK_PAGE = 'MaintenanceCompanyCertificateAdd';
const DEFAULT_COLUMN_VISIBILITY = getEmbeddedDefaultColumnVisibility(MASK_PAGE);
const CANONICAL_FIELD_ORDER = getEmbeddedCanonicalFieldOrder(MASK_PAGE);
const MASK_DIALOG_HELP_TEXT =
  uiT('MaintenanceTemplateList.MaskHelp');

export default function MaintenanceCompanyCertificateAdd({ maintenance_company, certificate, type = 'add', navigationContext }) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,openFilePreview, openChosenNotificationPreferences,getUserColor,getUserInitials} = useContext(UtilContext);
    const dateFmt = getDateFormat(state?.module_settings || []);
    const {user} = useContext(AuthContext);

    const canEditCompany = user?.permissions?.includes('edit maintenance-company');
    const hasListNavigationContext = navigationContext != null;

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);

    const resolvedCompany = useMemo(() => {
        if (maintenance_company?.id != null) return maintenance_company;
        const companyId = certificate?.company_id;
        if (companyId != null) {
            return state.maintenance_companies?.find((c) => c.id === companyId)
                ?? state.companies?.find((c) => c.id === companyId)
                ?? null;
        }
        return null;
    }, [maintenance_company, certificate, state.maintenance_companies, state.companies]);

    const [formMaintenanceCompanyCertificate,setformMaintenanceCompanyCertificate] = useState(resolvedCompany);
    const [formType, setFormType] = useState(type);
    const currentCompanyIdRef = useRef(resolvedCompany?.id ?? null);
    const prevCompanyIdRef = useRef(resolvedCompany?.id ?? null);

    useEffect(() => {
        if (resolvedCompany) setformMaintenanceCompanyCertificate(resolvedCompany);
    }, [resolvedCompany]);

    const company = formMaintenanceCompanyCertificate ?? resolvedCompany;
    const [showMaintenanceCertificateAdd, setShowMaintenanceCertificateAdd] = useState(false);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
//TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance-company"))?false:true);
    const [scrollIcons,setScrollIcons] = useState(() => {
        if (type === 'edit' && resolvedCompany && navigationContext != null) return !canEditCompany;
        return true;
    });
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    
    const [selectedCertificate,setSelectedCertificate] = useState(null);
    const [maintenanceCertificates, setMaintenanceCertificates] = useState([]);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const dateTimeFmt = `${dateFmt} HH:mm`;
    const canSetStandardMask = user?.permissions?.includes('set standard mask');

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const showDeactivatedCerts = showDeactivatedInLists(state.module_settings, 'maintenance');

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      extra.type = 'maintenance';
      extra.show_deactivated_certs = showDeactivatedCerts ? '1' : '0';
      const companyId = currentCompanyIdRef.current;
      if (companyId != null) extra.company_id = companyId;
      mergePagedStandardListFiltersAndSorters(extra, {
        getTable,
        tableBuiltForParams: tableBuiltRef.current,
        userMaskFilters: state.user_mask_filters,
        maskPage: MASK_PAGE,
        appendFilter: appendMaintenanceCompanyCertificateEmbeddedPagedFilter,
      });
      return extra;
    }, [pageSizePc, getTable, state.user_mask_filters, showDeactivatedCerts]);

    const fetchPaged = useCallback((url, merged) => tabulatorGet(url, merged).then((r) => ({
      data: r?.data ?? [],
      last_page: r?.last_page ?? 1,
      total: r?.total ?? 0,
    })), []);

    const ajaxRequestFunc = useMemo(
      () => createDedupedAjaxRequest(buildRequestParams, fetchPaged, inFlightRef, completedCacheRef),
      [buildRequestParams, fetchPaged]
    );

    useEffect(() => {
        currentCompanyIdRef.current = company?.id ?? null;
    }, [company?.id]);

    useEffect(() => {
        if (formType === 'edit' && company?.id && hasListNavigationContext) {
            setScrollIcons(!canEditCompany);
        } else {
            setScrollIcons(true);
        }
    }, [company, formType, canEditCompany, hasListNavigationContext]);

    const currentCompanyId = company?.id ?? null;
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const listType = 'maintenance';
      const isMyType = (p) => p?.type === listType;
      const onCreated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.created', id)) return;
        getRequest(`/api/company_certificates/${id}`).then((res) => {
          const row = res?.data?.data ?? res?.data ?? res;
          if (!row?.id || row.company_id !== currentCompanyId) return;
          const t = getTable();
          const rc = t?.getRow?.(row.id);
          if (rc) rc.update(row).catch(() => {});
          else t?.addData?.([row]);
        }).catch(() => {});
      };
      const onUpdated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.updated', id)) return;
        getRequest(`/api/company_certificates/${id}`).then((res) => {
          const row = res?.data?.data ?? res?.data ?? res;
          if (!row?.id) return;
          const t = getTable();
          const rc = t?.getRow?.(row.id) ?? t?.getRows?.().find((r) => r.getData?.()?.id === id);
          if (row.company_id === currentCompanyId) {
            if (rc) rc.update(row).catch(() => {});
            else t?.addData?.([row]);
          } else if (rc) rc.delete();
        }).catch(() => {});
      };
      const onDeleted = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.deleted', id)) return;
        const t = getTable();
        const row = t?.getRow?.(id) ?? t?.getRows?.().find((r) => r.getData?.()?.id === id);
        if (row) row.delete();
      };
      const refetch = () => { getTable()?.replaceData?.(); };
      channel.bind('company_certificate.created', onCreated);
      channel.bind('company_certificate.updated', onUpdated);
      channel.bind('company_certificate.deleted', onDeleted);
      channel.bind('company_certificate.activated', refetch);
      channel.bind('company_certificate.deactivated', refetch);
      return () => {
        channel.unbind('company_certificate.created', onCreated);
        channel.unbind('company_certificate.updated', onUpdated);
        channel.unbind('company_certificate.deleted', onDeleted);
        channel.unbind('company_certificate.activated', refetch);
        channel.unbind('company_certificate.deactivated', refetch);
      };
    }, [getTable, currentCompanyId]);

    useEffect(() => {
        getRequest('/api/company_certificates/paged?type=maintenance&size=500&page=1')
            .then((r) => setMaintenanceCertificates(r?.data ?? []))
            .catch(() => setMaintenanceCertificates([]));
    }, []);

    const [visibleCompanyCertificate,setVisibleCompanyCertificate] = useState(false);

    const [images,setImages] = useState('');

    const [fileList, setFileList] = useState([]);
    const fileListRef = useRef(null);

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);

    function addNewMaintenanceCompanyCertificate(){
        setShowMaintenanceCertificateAdd(true);
      }
      
    function copyMaintenanceCompanyCertificate(){
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length) { formik.setValues(selected[0]); setShowMaintenanceCertificateAdd(true); }
    }

    function editNewMaintenanceCompanyCertificate(){
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length) { formikUpdate.setValues(selected[0]); setSelectedCertificate(selected[0]); setVisibleCompanyCertificate(true); }
    }

    function hideEditMaintenanceCompanyCertificate(){
        formikUpdate.resetForm();
        setVisibleCompanyCertificate(false);
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
            initialValues:{
                name:'',description:'',type:'maintenance'},
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                let formData = new FormData();
                for (let value in values) {
                    formData.append(value, values[value]);
                }
                if (company?.id == null) return;
                formData.append("company_id", company.id);
                    postRequest('/api/company_certificates', formData,true)
                    .then((response) => {
                        getTable()?.replaceData?.();
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        setShowMaintenanceCertificateAdd(false);
                        formik.resetForm();
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                        getRequest("/api/companies").then((response) => {
                            dispatch({type:'load_companies',newCompanies:response.data});
                        });
                    }).catch((reason) => {
                        if(!navigator.online){
                            alert(t('ServiceTask.OfflineQueuedAlert'));
                        }
                        else{
                            alert(t('Common.Toast.ActionFailedDetail'));
                        }
                    })
            },
        });
    
        const formikUpdate = useFormik({
            initialValues: selectedCertificate == null ? {
                name:'',description:'',type:'maintenance'} : selectedCertificate,
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                let formData = new FormData();
                delete values.files;
                for (let value in values) {
                    formData.append(value, values[value] != null ? values[value] : "");
                }
                if (company?.id == null) return;
                formData.append("company_id", company.id);
                postRequest(`/api/company_certificates/update/${formikUpdate.values.id}`, formData,true)
                .then((response) => {
                    getTable()?.replaceData?.();
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    setVisibleCompanyCertificate(false);
                    formikUpdate.resetForm();
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    getRequest("/api/companies").then((response) => {
                        dispatch({type:'load_companies',newCompanies:response.data});
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                });
            },
        });

    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const resetDetailUiOnNavigate = useCallback(() => {
        setVisibleCompanyCertificate(false);
        setShowMaintenanceCertificateAdd(false);
        setSelectedCertificate(null);
        setImages('');
        setFileList([]);
        setUpdateFileList([]);
        if (fileListRef.current) fileListRef.current.value = null;
        if (updateFileListRef.current) updateFileListRef.current.value = null;
        setEditIcon(true);
        setDeleteIcon(true);
        setCopyIcon(true);
        setCloseTab(false);
        formik.resetForm();
        formikUpdate.resetForm();
    }, [formik, formikUpdate]);

    useEffect(() => {
        const prevId = prevCompanyIdRef.current;
        const nextId = company?.id;
        if (prevId === nextId) return;
        prevCompanyIdRef.current = nextId;
        if (nextId == null || !tableBuiltRef.current) return;
        inFlightRef.current = { sig: null, promise: null };
        completedCacheRef.current.clear();
        captureHScroll();
        refreshFromStart();
    }, [company?.id, captureHScroll, refreshFromStart]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildNavigateQueryParams = () => {
            const base = navigationContext ? navigationContextToQueryParams(navigationContext) : '';
            const params = new URLSearchParams(base);
            if (!params.has('type')) {
                params.set('type', 'maintenance');
            }
            return params.toString();
        };
        const applyCompany = (data) => {
            if (!data) return;
            resetDetailUiOnNavigate();
            currentCompanyIdRef.current = data.id ?? null;
            setformMaintenanceCompanyCertificate(data);
            setFormType('edit');
            setScrollIcons(!canEditCompany);
        };
        const buildFetchRecord = () => async (direction, currentId) => {
            setDialogText?.(t('Common.LoadingData'));
            setVisible?.(true);
            try {
                const q = buildNavigateQueryParams();
                const url = `/api/companies/navigate?direction=${direction}${currentId ? `&id=${currentId}` : ''}${q ? `&${q}` : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        return createAsyncNavigateHandlers(
            buildFetchRecord(),
            applyCompany,
            () => currentCompanyIdRef.current ?? company?.id
        );
    }, [navigationContext, company?.id, canEditCompany, resetDetailUiOnNavigate, setDialogText, setVisible]);

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length === 1){
            if(user.permissions?.includes("edit maintenance-company"))setEditIcon(false);
            if(user.permissions?.includes("delete maintenance-company"))setDeleteIcon(false);
            if(user.permissions?.includes("add maintenance-company"))setCopyIcon(false);
            setSelectedCertificate(selected[0]);
        }
    }

    function onEditRow(maintenance_company){
        formikUpdate.setValues(maintenance_company);
        setSelectedCertificate(maintenance_company);
        setVisibleCompanyCertificate(true);      
    };

    function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
    }

    function DeactivationDateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const d = rowData?.deactivation_date;
        return <span>{d ? DateTime.fromISO(d).toFormat(dateFmt) : '—'}</span>;
    }
    function CertificateStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const v = rowData?.deactivation_date;
        return <span>{v ? t('Status.Deactivated') : 'Aktívny'}</span>;
    }

    const remoteHeaderFilter = useCallback(() => true, []);

    const auditTailColumns = useMemo(
      () =>
        buildAuditTabulatorColumns({
          profile: TABULATOR_AUDIT_PROFILES.createdByUpdatedBy,
          includeId: false,
          dateFormat: dateFmt,
          dateTimeFormat: dateTimeFmt,
          getUserColor,
          getUserInitials,
          textHeaderFilter: inputOnEnterHeaderFilter,
          remotePassthrough: true,
        }),
      [dateFmt, dateTimeFmt, getUserColor, getUserInitials]
    );

    const columns = useMemo(
      () => [
        {
          title: '',
          field: 'rowSelection',
          formatter: 'rowSelection',
          titleFormatter: 'rowSelection',
          hozAlign: 'center',
          width: 44,
          minWidth: 44,
          headerSort: false,
          resizable: false,
          frozen: true,
          print: false,
          download: false,
        },
        {
          title: '',
          field: 'editor',
          hozAlign: 'center',
          width: 44,
          minWidth: 44,
          headerSort: false,
          formatter: reactFormatter(<EditRowFormatter />),
          resizable: false,
          frozen: true,
          print: false,
          download: false,
        },
        {
          title: 'ID',
          field: 'id',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
          widthGrow: 1,
          sorter: 'number',
          hozAlign: 'left',
        },
        {
          title: t('Common.Name'),
          field: 'name',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Name')),
          widthGrow: 1,
        },
        {
          title: t('Common.Deactivation'),
          field: 'deactivation_date',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Deactivation')),
          formatter: reactFormatter(<DeactivationDateFormatter />),
        },
        {
          title: t('Common.CertificateStatus'),
          field: 'certificate_status',
          headerFilter: primeMultiSelectHeaderFilter,
          headerFilterParams: {
            options: [
              { label: 'Aktívny', value: 'Aktívny' },
              { label: t('Status.Deactivated'), value: "Deaktivovaný" },
            ],
            placeholder: t('Common.CertificateStatus'),
          },
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.CertificateStatus'), 'multiselect'),
          formatter: reactFormatter(<CertificateStatusFormatter />),
        },
        {
          title: t('Common.Column.Responsible'),
          field: 'responsible.name',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Column.Responsible')),
          widthGrow: 1,
        },
        {
          title: t('Common.RequiredAttachment'),
          field: 'required_attachment',
          headerFilter: primeMultiSelectHeaderFilter,
          headerFilterParams: {
            options: [
              { label: t('Common.Yes'), value: "Áno" },
              { label: t('Common.No'), value: "Nie" },
            ],
            placeholder: t('Common.RequiredAttachment'),
          },
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.RequiredAttachment'), 'multiselect'),
          formatter: (cell) => (cell.getValue() ? t('Common.Yes') : t('Common.No')),
        },
        {
          title: t('Common.Description'),
          field: 'description',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Description')),
          widthGrow: 1.2,
        },
        ...auditTailColumns,
      ],
      [auditTailColumns, remoteHeaderFilter]
    );

    const closeMenu = useCallback(() => {
      setTimeout(() => {
        OverflowMenuProvider.setVisible?.(null);
        setExpandedKeys({});
      }, 0);
    }, []);

    const hasApplicableStandardMask = useMemo(
      () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved)),
      [state.standard_mask_filters]
    );

    const openMaskDialog = useCallback(
      createOpenMaskDialog({
        columnsVisible,
        setColumnsVisible,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        mergeVisibilityFromSaved: (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved),
        setMaskVisible,
        closeMenu,
      }),
      [columnsVisible, closeMenu]
    );

    const saveUserMaskColumns = useCallback(
      createSaveUserMaskColumns({
        maskPage: MASK_PAGE,
        getTable,
        setUserMaskFilter,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        columnsVisible,
        setColumnsVisible,
        setMaskVisible,
        toast,
      }),
      [columnsVisible, getTable, setUserMaskFilter, toast]
    );

    const confirmSaveStandardMask = useCallback(
      createConfirmSaveStandardMask({
        maskPage: MASK_PAGE,
        getTable,
        setStandardMaskFilter,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        toast,
      }),
      [getTable, setStandardMaskFilter, toast]
    );

    const confirmApplyStandardLayoutToUserMask = useCallback(
      createConfirmApplyStandardLayoutToUserMask({
        maskPage: MASK_PAGE,
        state,
        setUserMaskFilter,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        mergeVisibilityFromSaved: (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved),
        toast,
        closeMenu,
        onAppliedToTable: ({ colsForSave, attributes }) => {
          const table = getTable();
          if (!table) return;
          isRestoringRef.current = true;
          applyMaintenanceCompanyEmbeddedColumnLayout(table, attributes, CANONICAL_FIELD_ORDER);
          setColumnsVisible(colsForSave);
          applyEmbeddedDataColumnVisibility(table, MASK_PAGE, colsForSave);
          setTimeout(() => {
            isRestoringRef.current = false;
            table.redraw?.(true);
            captureHScroll();
            refreshFromStart();
          }, 0);
        },
      }),
      [state, closeMenu, getTable, setUserMaskFilter, toast, captureHScroll, refreshFromStart]
    );

    const setMask = useCallback(
      createMaskSetFieldHandler({
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        columnsVisible,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
        toast,
      }),
      [columnsVisible, getTable, toast]
    );

    const maskSelectAll = useCallback(
      createMaskSelectAllHandler({
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
      }),
      [getTable]
    );

    const maskDeselectAll = useCallback(
      createMaskDeselectAllHandler({
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
      }),
      [getTable]
    );

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  
    

    const akcieSubItems = buildMaintenanceMaskAkcieSubItems({
      maskPage: MASK_PAGE,
      getTable,
      setUserMaskFilter,
      cleanSorters,
      captureHScroll,
      refreshFromStart,
      closeMenu,
      openMaskDialog,
      openChosenNotificationPreferences,
      hasApplicableStandardMask,
      confirmApplyStandardLayoutToUserMask,
      itemRenderer,
    });

    const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: akcieSubItems,
      },
    ];

      const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
      }

    const acceptCertificate = () => {
            const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
            let itemsProcessed = 0;
            rows_to_delete.forEach((item, index, array) => {
              deleteRequest(`/api/company_certificates/${item.id}`)
                  .then((response) => {
                    itemsProcessed++;
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                    getTable()?.replaceData?.();
                    if(itemsProcessed === array.length) {
                        getRequest("/api/companies").then((response) => {
                            dispatch({type:'load_companies',newCompanies:response.data});
                        });
                    }
                  }).catch((reason) => {
                      alert(reason);
                      toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
                  })
            });
        }

      const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCertificate
        });
    };

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'> 
            <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewMaintenanceCompanyCertificate()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyMaintenanceCompanyCertificate()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editNewMaintenanceCompanyCertificate()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" type="button" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" type="button" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" type="button" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" type="button" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Maintenance.EditServiceCompanyCertificates'),"MaintenanceCompanyCertificateAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("MaintenanceCompanyCertificateAdd",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          {canSetStandardMask ? (
            <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
              <button
                type="button"
                title={t('Common.SaveStandardMask')}
                aria-label={t('Common.SaveStandardMask')}
                onClick={confirmSaveStandardMask}
                className="flex items-center justify-center"
              >
                <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
              </button>
            </div>
          ) : null}
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={10} size={63}>
        <div className="w-full relative flex flex-col h-full overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.CERTIFIKATY_SERVISNEJ_FIRMY')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.CompanyNameUpper')}</label>
                        <input
                        readOnly={true}
                            name='name'
                            type="text"
                            value={company?.name ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                        readOnly={true}
                            name='tel_number'
                            type="text"
                            value={company?.tel_number ?? ''}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                        readOnly={true}
                            name='email'
                            type="text"
                            value={company?.email ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                        readOnly={true}
                            name='contact_person'
                            type="text"
                            value={company?.contact_person ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='address'
                            type="text"
                            value={company?.address ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                        readOnly={true}
                            name='fax'
                            type="text"
                            value={company?.fax ?? ''}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='web_address'
                            type="text"
                            value={company?.web_address ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                        readOnly={true}
                            name='gauge_name'
                            type="text"
                            value={company?.description ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>    
            </div> 
            </div>
            </div> 
             </SplitterPanel>
             <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={37} style={{minHeight: '110px'}}>
             <ReactTabulator
               key={`maintenance-certificate-add-${company?.id ?? 'none'}`}
               data={undefined}
               className='h-[calc(100vh_-_176px)]'
               onRef={(r) => (ref.current = r?.current)}
               columns={columns}
               events={{
                 rowSelectionChanged: onSelectRow,
                 headerFilterChanged: () => {
                   if (!isRestoringRef.current) {
                     captureHScroll();
                     refreshFromStart();
                   }
                 },
                 sortChanged: () => {
                   if (!isRestoringRef.current) {
                     captureHScroll();
                     refreshFromStart();
                   }
                 },
                 renderComplete: () => restoreHScroll(),
                 tableBuilt: () => {
                    const t = getTable();
                    if (!t) return;
                    isRestoringRef.current = true;
                    const effective = getEffectiveMask(MASK_PAGE, state);
                    if (effective?.type === 'user' && effective.userMask) {
                      restoreMaintenanceCompanyEmbeddedUserMaskToTable(t, effective.userMask, {
                        canonicalFieldOrder: CANONICAL_FIELD_ORDER,
                        setColumnsVisible,
                        applyColumnVisibilityFn: (table, cols) => {
                          const merged = mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, cols);
                          setColumnsVisible(merged);
                          applyEmbeddedDataColumnVisibility(table, MASK_PAGE, merged);
                        },
                      });
                    } else if (effective?.type === 'standard' && effective.standardMask) {
                      restoreMaintenanceCompanyEmbeddedUserMaskToTable(t, effective.standardMask, {
                        canonicalFieldOrder: CANONICAL_FIELD_ORDER,
                        setColumnsVisible,
                        applyColumnVisibilityFn: (table, cols) => {
                          const merged = mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, cols);
                          setColumnsVisible(merged);
                          applyEmbeddedDataColumnVisibility(table, MASK_PAGE, merged);
                        },
                      });
                    } else {
                      applyEmbeddedDataColumnVisibility(t, MASK_PAGE, columnsVisible);
                    }
                    setTimeout(() => {
                      isRestoringRef.current = false;
                    }, 0);
                    tableBuiltRef.current = true;
                    refreshFromStart();
                  },
                 ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
               }}
               options={{
                 renderHorizontal:"virtual",movableColumns: true,rowHeight:42,headerSortTristate:true,layout:'fitColumns',
                 printAsHtml:true,printHeader: () => buildCanonicalPrintHeaderHtml({
                      branding: state?.branding,
                      productFallbackSrc: defaultProductLogoSrc,
                      companySettingsPrint: state?.company_settings_print,
                      moduleSettings: state?.module_settings,
                      title: t('Print.Title.MaintenanceCompanyCertificateAdd'),
                      printDateLabel: t('Print.DateLabel'),
                    }),
                    printFooter: () => buildCanonicalPrintFooterHtml({
                      companySettingsPrint: state?.company_settings_print,
                    }),printRowRange:"active",
                 autoResize:false,
                 ajaxURL: '/api/company_certificates/paged',
                 progressiveLoad: 'scroll',
                 progressiveLoadScrollMargin: 80,
                 paginationSize: pageSizePc,
                 pagination: false,
                 filterMode: 'remote',
                 sortMode: 'remote',
                 ajaxRequestFunc,
                 dataLoader: true,
                 dataLoaderLoading: t('Common.LoadingData'),
                 dataLoaderError: t('Common.LoadFailed'),
               }}/>
            </SplitterPanel>
            </Splitter>
            </div>
            <Dialog header={t('Common.AddCertificate')} visible={showMaintenanceCertificateAdd} style={{ width: '40vw' }} onHide={() => setShowMaintenanceCertificateAdd(false)}>
            <form onSubmit={formik.handleSubmit}>
            <div>
                <div> 
                    <label
                        htmlFor="name"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.Name')}</label>
                    <input
                        name='name'
                        type="text"
                        onChange={formik.handleChange} value={formik.values.name}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div> 
                    <label 
                    htmlFor='description'
                    className='font-bold text-black'>{t('Common.Description')}</label>
                    <input 
                    name='description'
                    type='text'
                    onChange={formik.handleChange} value={formik.values.description}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.SaveState')}</button>         
            </form>
            </Dialog>
            <Dialog header={t('Common.EditCertificate')} visible={visibleCompanyCertificate} style={{ width: '40vw' }} onHide={() => hideEditMaintenanceCompanyCertificate()}>
    <form onSubmit={formikUpdate.handleSubmit}>
    <div>
                <div> 
                <label
                    htmlFor="name"
                    className="block text-md font-semibold text-gray-800"
                >{t('Common.Name')}</label>
                <input
                    name='name'
                    type="text"
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.name}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
                </div>
                <div> 
                    <label 
                    htmlFor='description'
                    className='font-bold text-black'>{t('Common.Description')}</label>
                    <input 
                    name='description'
                    type='text'
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.SaveState')}</button>         
            </form>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
          <p className="text-sm text-gray-600 mb-2">{MASK_DIALOG_HELP_TEXT}</p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
            <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
          </div>
          {columns.map((item) => {
            if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
            const field = String(item.field);
            const inputId = `${MASK_PAGE}-${field}`;
            return (
              <div key={field} className="flex flex-row border border-black rounded-md p-2 m-1">
                <MaintenanceMaskDialogCheckbox field={field} inputId={inputId} title={item.title} columnsVisible={columnsVisible} onChange={setMask} />
                <label htmlFor={inputId} className={`ml-2 ${field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>
              </div>
            );
          })}
          <button type="button" onClick={saveUserMaskColumns} className="m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700">{t('Common.SaveUpper')}</button>
        </div>
      </Dialog>
</> 
            );
} 
